export default {
  surveyBuilder: {
      farmName: "Ferme",
      farmerName: "Nom du Fermier",
      scores: "Scores",
      clearSelection: "Effacer tous les utilisateurs",
      addNewSurvey: "Ajouter un nouveau sondage",
      surveyTitle: "Titre du sondage",
      surveyName: "Nom du sondage",
      surveyDescription: "Description du sondage",
      describeSurvey: "Décrire le sondage",
      enableScheduling: "Activer la planification",
      enableSchedulingInfo: "Possibilité de définir une date ou une heure spécifique pour l'évaluation.",
      selectedDate: "Date sélectionnée",
      multiStepSurvey: "Sondage à étapes multiples",
      multiStepSurveyDetails: "En fonction du nombre de questions dans une étape, toutes les questions du sondage seront regroupées et affichées par étapes.",
      multiStep: "Étapes multiples",
      noQuestionEachStep: "Nombre de questions dans chaque étape",
      surveyStatus: "Statut du sondage",
      surveyStatusDetails: "Le sondage peut être activé uniquement après l'ajout des questions. Activer un sondage permettra aux agriculteurs de commencer les soumissions.",
      selectUsers: "Sélectionner les utilisateurs",
      selectUsersDetails: "Si la sélection des utilisateurs est désactivée, le sondage sera disponible pour tous les utilisateurs. Si vous activez la sélection des utilisateurs, vous pourrez sélectionner plusieurs utilisateurs dans l'étape suivante.",
      linkWithFarms: "Lier avec les fermes",
      linkWithFarmsDetails: "Si activé, le sondage sera lié aux fermes individuelles. Si un fermier a plusieurs fermes, chaque ferme aura son propre sondage.",
      enabled: "Activé",
      disabled: "Désactivé",
      cancel: "Annuler",
      next: "Suivant",
      surveySettings: "Paramètres du sondage",
      selectSurveyUsers: "Sélectionner les utilisateurs du sondage",
      selectToProceed: "Veuillez sélectionner les utilisateurs pour continuer",
      searchUsers: "Rechercher des utilisateurs",
      usersSelected: "Utilisateurs sélectionnés",
      conditional: "Conditionnel",
      autoConditional: "Conditionnel automatique",
      userName: "Nom d'utilisateur",
      email: "Email",
      membershipType: "Type d'abonnement",
      membershipValidity: "Validité de l'abonnement",
      membershipRemainingDays: "Nombre de jours restants",
      membershipRole: "Rôle du membre",
      accountProgress: "Progrès du compte",
      status: "Statut",
      active: "Actif",
      deactivated: "Désactivé",
      continue: "Continuer",
      questions: "Questions",
      questionInfo: "Le texte de la question d'évaluation qui sera présenté au répondant.",
      responses: "Réponses",
      deleteSurvey: "Supprimer le sondage",
      editSurvey: "Modifier le sondage",
      type: "Type",
      typeInfo: "Un menu déroulant pour spécifier le type de saisie requis pour la question, comme un bouton radio, une case à cocher ou une saisie de texte.",
      compulsory: "Obligatoire",
      createSurvey: "Créer un sondage",
      surveyBuilder: "Créateur de sondages",
      surveyList: "Liste des sondages",
      farm: "Ferme",
      responseDate: "Date de réponse",
      viewSurvey: "Voir le sondage",
      question: "Question",
      settings: "Paramètres",
      addQuestion: "Ajouter une question",
      surveysSubmitted: "Sondages soumis",
      surveyDetail: "Détail du sondage",
      conditionStatus: "Statut de la condition",
      conditionStatusDesc: "Les utilisateurs correspondant aux conditions deviendront automatiquement éligibles pour le sondage.",
      endSurvey: "Terminer le sondage",
      publishSurvey: "Publier le sondage",
      copy: "Copier",
      view: "Voir",
      startDate: "Date de début",
      endDate: "Date de fin",
      chooseDate: "Choisir une date",
      select: "Sélectionner",
      addSurveyQuestion: "Ajouter une question au sondage",
      editSurveyQuestion: "Modifier la question du sondage",
      questionScore: "Score de la question",
      mandatory: "Obligatoire",
      yes: "Oui",
      no: "Non",
      options: "Options",
      typeHere: "Tapez ici",
      add: "Ajouter",
      optionsHint: "Veuillez entrer pour ajouter une réponse ou cliquer sur Ajouter",
      surveyProgress: "Sondage en cours",
      allResponses: "Résumé de toutes les réponses",
      responseQuestion: "Réponses par question",
      dateSubmitted: "Date soumise",
      answer: "Réponses",
      totalScore: "Score total",
      score: "Score",
      singleSelection: "Sélection unique",
      multipleSelection: "Sélection multiple",
      if: "Si",
      then: "alors",
      noResponse: "Aucune réponse",
      noSurveyFound: "Aucun sondage trouvé",
      createNewSurvey: 'Veuillez créer un sondage en utilisant le bouton "Créer un sondage" ci-dessus',
      cannotPublish: "Impossible de publier un sondage désactivé!",
      deleteSurveyWarn: "Êtes-vous sûr de vouloir supprimer le sondage ? Si vous le supprimez, toutes les questions et soumissions seront définitivement supprimées.",
      noQuestionFound: "Aucune question trouvée",
      createQuestion: 'Veuillez ajouter une question d\'abord en utilisant le bouton "AJOUTER DES QUESTIONS" ci-dessus',
      deleteQuestion: "Êtes-vous sûr de vouloir supprimer cette question ?",
      applyChanges: "Comment souhaitez-vous appliquer ces modifications ?",
      editFutureSurveys: "MODIFIER UNIQUEMENT LES SONDAGES FUTURS",
      editLiveSurveyOnly: "MODIFIER UNIQUEMENT LE SONDAGE EN DIRECT",
      surveyIsLive: "Veuillez noter que le sondage est actuellement en direct, et modifier une question à ce moment peut affecter les soumissions précédentes. Pour éviter tout problème, vous pouvez envisager de créer une copie du sondage pour apporter des modifications aux questions.",
      clickToCopy: "Cliquez ici pour créer une copie du sondage",
      applyChangesNow: "APPLIQUER LES MODIFICATIONS MAINTENANT",
      copySurvey: "Copier le sondage",
      changeCopySurveyName: "Vous pouvez changer le nom de la version copiée du sondage.",
      textField: "Champ de texte",
      textArea: "Zone de texte",
      textFieldNumeric: "Champ de texte numérique",
      radioButton: "Bouton radio",
      checkBoxes: "Cases à cocher",
      fileAttachment: "Pièce jointe",
      digitalSignature: "Signature numérique",
      gpsLocation: "Emplacement GPS",
      dynamicFarmer: "Fermier dynamique",
      dynamicGeofence: "Géorepérage dynamique",
      dynamicCrop: "Culture dynamique",
      dynamicEquipment: "Équipements dynamiques",
      downloadSurvey: "Télécharger le sondage",
      downloadQuestion: "Télécharger uniquement les questions",
      downloadResponse: "Télécharger toutes les réponses",
      chooseFileFormat: "Choisir le format de fichier",
      surveyTitleLength: "Le titre du sondage doit comporter moins de 100 caractères",
      selectAllFiltered: "Sélectionner tout le filtré",
      surveyDownloads: "Téléchargements du sondage",
  },
}
